import React, { useContext, useMemo } from 'react'
import { Dialog, DialogContent, Typography, ClearIcon, Grid, styledComponent } from '@hermes/web-components'
import { SearchProfilesPageContext } from '../../../providers/SearchProfilesPage'
import dynamic from 'next/dynamic'
import ProfileInfoWindow from './ProfileInfoWindow'
import useGetProfilesToShow from '../../../hooks/useGetProfilesToShow'
import { profilesToMarkers } from '../../../utils/mapTransformers'
import useTranslateMessage from '../../../hooks/useTranslateMessage'

const Map = dynamic(() => import('../../Map'), { ssr: false })

type SearchMapModalProps = {
  isOpen: boolean
  onClose: () => void
}

const StyledDialog = styledComponent(Dialog)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '& .MuiDialog-paper': {
      margin: 0,
      width: '100%',
      height: '100%',
      borderRadius: 0,
      maxHeight: 'none'
    },
    '& .MuiDialogContent-root': {
      width: '100%'
    }
  }
}))

const SearchMapModal = ({ isOpen, onClose }: SearchMapModalProps) => {
  const translate = useTranslateMessage()
  const profilesToShow = useGetProfilesToShow()
  const {
    state: { filters }
  } = useContext(SearchProfilesPageContext)

  const markers = useMemo(
    () => profilesToMarkers(profilesToShow, ProfileInfoWindow, Number(filters.distance || 25)),
    [profilesToShow, filters.distance]
  )

  return (
    <StyledDialog open={isOpen} onClose={onClose} maxWidth="md">
      <DialogContent sx={{ px: 4, py: 3, paddingBottom: '16px', width: '100vw', maxWidth: 745 }}>
        <Grid container justifyContent="space-between" wrap="nowrap">
          <Typography fontWeight={200} variant="h5">
            {translate('map')}
          </Typography>
          <ClearIcon onClick={onClose} sx={{ cursor: 'pointer' }} />
        </Grid>
      </DialogContent>
      <DialogContent sx={{ px: 4, py: 3, pt: 0, width: '100vw', height: '50vh', maxWidth: 745 }}>
        <Map markers={markers} />
      </DialogContent>
    </StyledDialog>
  )
}

export default SearchMapModal
